import { Text } from '@mantine/core';

type TenantCardHeaderProps = {
  companyName: string;
};

export const TenantCardHeader = ({ companyName }: TenantCardHeaderProps) => (
  <Text ff="heading" fz={16} fw={500} c="black.6" mb="md">
    {companyName}
  </Text>
);
